import { AdvicePriceFormValues } from "../AdviceCards/interfaces";
import { getMonthlyPrice } from "../AdviceCards/utils";
import { useAdviceProductsAdviced } from "./useAdviceProductsAdviced";

export const useTotalPrice = (formValues: AdvicePriceFormValues): number => {
  const {
    disabilityProductAdviced,
    deathProductAdviced,
    criticalIllnessProductAdviced,
  } = useAdviceProductsAdviced();

  let totalPrice = 0;
  if (formValues.disabilityCheckedToPurchase) {
    totalPrice += disabilityProductAdviced
      ? getMonthlyPrice(disabilityProductAdviced.insurancePrice)
      : 0;
  }
  if (formValues.deathCheckedToPurchase) {
    totalPrice += deathProductAdviced
      ? getMonthlyPrice(deathProductAdviced.insurancePrice)
      : 0;
  }
  if (formValues.criticalIllnessCheckedToPurchase) {
    totalPrice += criticalIllnessProductAdviced
      ? getMonthlyPrice(criticalIllnessProductAdviced.insurancePrice)
      : 0;
  }
  return totalPrice;
};
